// Components imports
import StandAlone from "./components/StandAlone";


// React instances
global.React = require('react');
global.ReactDOM = require('react-dom');
global.ReactDOMServer = require('react-dom/server');

// Components
global.StandAlone = StandAlone;
